(function () {
    'use strict';

    angular
        .module('commissionsPayment')
        .controller('InvoiceCommissionModalController', InvoiceCommissionModalController);

    InvoiceCommissionModalController.$inject = ['$state', '$scope', '$timeout', '$stateParams', '$uibModalInstance', 'toastr', 'InvoicesService' ,'invoice_commission', 'getInvoicesCommissions', 'CommissionService', 'SellerService', 'AccountService'];

    function InvoiceCommissionModalController($state, $scope, $timeout, $stateParams, $uibModalInstance, toastr, InvoicesService, invoice_commission, getInvoicesCommissions, CommissionService, SellerService, AccountService) {
        var vm = this;
        vm.invoice_commission     = invoice_commission;
        vm.getInvoicesCommissions = getInvoicesCommissions;
        vm.invoice                = [];
        vm.commissions_seller     = [];
        vm.statusTransform        = {'waiting':'Waiting', 'authorized':'Authorized', 'paid':'Paid'};
        vm.commissionTypeSelected = [];
        vm.commissionTypeList     = '';
        vm.invoiceCommissionId    = '';
        vm.buttonType             = '';
        
        
        vm.newCommission             = ''; 
        vm.newSellerSelected         = ''; 
        vm.newCommissionTypeSelected = {};
        vm.newCategorySelected       = {};
        vm.addCommissionFlag         = false;
        vm.categoryList              = '';
        vm.sellers                   = [];
        vm.sellerSelected            = '';
        vm.selectOptionAll           = [{name: '--- All ---', id: -1}];
        
        vm.invoicesAccountSelected  = [];
        vm.invoicesAccountList      = '';
        vm.dateOptions            = {
            autoUpdateInput: true,
            autoApply:true,
            singleDatePicker: true,
            locale: {
                format: 'DD/MMM/YYYY',
                cancelLabel: 'Close'
            }
        };
        
        vm.edit                   = edit;
   // vm.getInvoice             = getInvoice;
        vm.getAllCommissionsType  = getAllCommissionsType;
        vm.getCostCenterFullName  = getCostCenterFullName;
        vm.authorizeCommission    = authorizeCommission;
        vm.getCostCenterCategory  = getCostCenterCategory;
        vm.getInvoicesAccount     = getInvoicesAccount;
        vm.getCommissions         = getCommissions;
        vm.addCommission          = addCommission;
        vm.saveNewCommission      = saveNewCommission;
        vm.updateCommission       = updateCommission;
        vm.queryPrepare           = queryPrepare;
        vm.loadSellers            = loadSellers;  
        vm.clearForm              = clearForm;
        vm.cancel                 = cancel;
        vm.deleteCommission       = deleteCommission;
        vm.getStatusClass         = getStatusClass;

        function activate() {
            vm.getCommissions().then(function(response) {
                vm.commissions_seller = Object.values(response.data.data);
            }).catch(function(err) {
            });
            //vm.getInvoice();
            vm.getAllCommissionsType();
            vm.getCostCenterCategory();    
            vm.getInvoicesAccount();    
            vm.loadSellers();
        }

        function getCostCenterFullName (cost_center_id) {
            var costCenterFullName = '';
            costCenterFullName = vm.categoryList.filter(function(item){
                return item.id == cost_center_id;
             })[0];
             return costCenterFullName.name_with_prefix;
        }

        function authorizeCommission(commission_id) {
            var query = {};
            query['invoice_commission_id'] = commission_id;
            CommissionService.authorizeCommission(query).then(function(response) {
                vm.getCommissions().then(function(response) {
                    toastr.success('Successfully authorized!');
                    vm.commissions_seller = Object.values(response.data.data);
                }).catch(function(err) {
                });
            }).catch(function(err) {
            });
        }

        function getAllCommissionsType() {
            CommissionService.getAllCommissionsType().then(function(response) {
                vm.commissionTypeList = response.data;
            }).catch(function(err) {
            });
        }
        function getCostCenterCategory() {
            InvoicesService.getInvoicesCostCenterCategory().then(function(response) {
                vm.categoryList = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoicesAccount() {        
            AccountService.getAccountsCommissions().then(function(response) {
                vm.invoicesAccountList = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoice() {
            // var query = [];
            // query['invoice_id'] = vm.invoice_commission[0].invoice_id;
            // InvoicesService.getInvoiceById(query).then(function(response){
            //     vm.invoice = respons.data;
            //     vm.invoice.payment_date = new Date(vm.invoice.payment_date.replace(/-/g,"/"));
            //     vm.invoice.due_date = new Date(vm.invoice.due_date.replace(/-/g,"/"));
            // });
        }

        function getCommissions() {
            var query = {};
            query['invoice_id'] = vm.invoice_commission[0].invoice_id;
            query['return_total_by_seller'] = false;
            return CommissionService.getCommissionsByFilter(query);
        }

        function loadSellers() {
            SellerService.getStaff().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function addCommission() {
            vm.addCommissionFlag = true;
            vm.buttonType = 'save';
        }

        function saveNewCommission(query) {
            CommissionService.saveCommission(query).then(function(response) {
                vm.getCommissions().then(function(response) {
                    vm.commissions_seller = Object.values(response.data.data);
                    vm.clearForm();
                    toastr.success('Successfully saved!');
                    vm.getInvoicesCommissions();
                }).catch(function(err) {
                });
            }).catch(function(err) {
            });
        }

        function updateCommission(query) {
            CommissionService.updateCommission(query).then(function(response) {
                vm.getCommissions().then(function(response) {
                    vm.commissions_seller = Object.values(response.data.data);
                    vm.clearForm();                    
                    toastr.success('Successfully updated!');
                    vm.getInvoicesCommissions();
                }).catch(function(err) {
                });
            }).catch(function(err) {
            });
        }

        function queryPrepare(type) {
            var query = {};
            query['seller_id'] = vm.newSellerSelected.id;
            query['commission_rate'] = vm.newCommission;
            query['commission_type'] = vm.newCommissionTypeSelected.slug;
            query['cost_center_id'] = vm.newCategorySelected.id;
            query['account_id'] = vm.newAccountSelected.id;
            query['invoice_id'] = vm.invoice_commission[0].invoice_id;
            query['status'] = vm.invoice_commission[0].invoice_id == 'paid'?'authorized':'waiting';
            if(type == 'save') {
                vm.saveNewCommission(query);
            } else {
                query['invoice_commission_id'] = vm.invoiceCommissionId;
                vm.updateCommission(query);    
            }
        }

        function edit(commission) {
            vm.newSellerSelected = vm.sellers.filter(function(item){
               return item.id == commission.seller_id;
            })[0];
            vm.newCategorySelected = vm.categoryList.filter(function(item){
               return item.id == commission.cost_center_id;
            })[0];
            vm.newAccountSelected = vm.invoicesAccountList.filter(function(item){
                return item.id == commission.account_id;
            })[0];
            vm.newCommissionTypeSelected = vm.commissionTypeList.filter(function(item){
                return item.slug == commission.commission_type;
            })[0];
            vm.newCommission = commission.commission_rate;
            vm.addCommissionFlag = true;
            vm.buttonType = 'edit';
            vm.invoiceCommissionId = commission.invoice_commission_id;
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function clearForm() {
            vm.newSellerSelected = '';
            vm.newCommission = '';
            vm.newCommissionTypeSelected  = {};
            vm.newCategorySelected  = {};
            vm.newAccountSelected  = {};
            vm.invoice_commission[0].invoice_id == 'paid'?'authorized':'waiting';
            vm.addCommissionFlag = false;
            vm.invoiceCommissionId = '';
            vm.buttonType = '';
        }
        
        function deleteCommission(commission) {
            var query = [];
            query['invoice_commission_id'] = commission.invoice_commission_id;
            query['invoice_id'] = commission.invoice_id;
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to delete this commission?')
                .set('onok', function (){
                    CommissionService.destroy(query).then(function(response) {
                        var data = response.data;
                        if (data.length === 0) {
                            vm.getCommissions().then(function(response) {
                                vm.commissions_seller = Object.values(response.data.data);
                                toastr.success('Successfully deleted!');
                                vm.getInvoicesCommissions();
                            }).catch(function(err) {
                            });
                        }
                    }).catch(function(err) {
                    });
                })
                .show();
        }

        function getStatusClass(status) {
            if (status === 'waiting')
                return 'label-default';
            else if (status === 'authorized')
                return 'label-warning';
            else if (status === 'paid')
                return 'label-success';
        }

        activate();
    }

})();